import { useProductPageStore } from '../../contexts/ProductPageStore'
import styles from './inStorePickupDrawer.module.scss'

import { useMemo } from 'react'

import ErrorBoundary from 'Clutch/UtilityComponents/ErrorBoundary'

import useFeatureFlag from 'Clutch/Hooks/useFeatureFlag'

import Drawer from 'Clutch/Molecules/NewDrawer/Drawer'

import Card from 'Clutch/Atoms/Card'
import Svg from 'Clutch/Atoms/Svg'
import Typography from 'Clutch/Atoms/Typography'

const InStorePickupDrawer = ({}) => {
  const isInStorePickupDrawerOpen = useProductPageStore((x) => x.isInStorePickupDrawerOpen)
  const freeShippingAndAvailability = useProductPageStore((x) => x.freeShippingAndAvailability)
  const activeInStorePickupLocations = useProductPageStore((x) => x.activeInStorePickupLocations)
  const hideInStorePickupDrawer = useProductPageStore((x) => x.hideInStorePickupDrawer)

  const isWvCounterActive = useFeatureFlag('WV_Counter_Web_Quotes_Enabled')
  const activePickupWarehouses = ['SMI-LNK', 'SMI-PHX']
  if (isWvCounterActive) {
    activePickupWarehouses.push('SMI-WV')
  }

  const storeConfigMap = useMemo(() => {
    const map = new Map()

    activeInStorePickupLocations?.forEach((loc) => {
      map.set(loc.warehouseId, {
        cityState: loc.cityState,
        cityStateZip: loc.cityStateZip,
        street: loc.addressLine1,
        fullWeeklyStoreHours: loc.fullWeeklyStoreHours,
      })
    })

    return map
  }, [activeInStorePickupLocations])

  return (
    <Drawer
      location={'right'}
      isOpen={isInStorePickupDrawerOpen}
      onClose={() => hideInStorePickupDrawer()}
      title={'Store Pickup Availability'}
      portalId={'isp_availability_drawer'}
    >
      {freeShippingAndAvailability &&
        (freeShippingAndAvailability.warehouseAvailability || [])
          .filter((warehouse) => activePickupWarehouses.includes(warehouse.warehouseId))
          .map((warehouse) => (
            <ErrorBoundary key={`warehouse_${warehouse.warehouseId}`}>
              <Card layer={0} fill>
                <div className={styles.availabilityCardContainer}>
                  {warehouse.availability === 'InStock' ? (
                    <Svg icon={'trackorder'} intent={'positive'} size={2} />
                  ) : (
                    <Svg icon={'unavailable'} size={2} />
                  )}
                  <div className={styles.availabilitySection}>
                    {warehouse.availability === 'InStock' ? (
                      warehouse.availabilityString === 'Limited qty' ? (
                        <Typography
                          size={1}
                          font={'heading'}
                          intent={'warning'}
                          className={styles.availability}
                          data-testid={`${warehouse.warehouseId}_limited`}
                        >
                          Limited Quantity
                        </Typography>
                      ) : (
                        <Typography
                          size={1}
                          font={'heading'}
                          intent={'positive'}
                          className={styles.availability}
                          data-testid={`${warehouse.warehouseId}_available`}
                        >
                          Available
                        </Typography>
                      )
                    ) : (
                      <Typography
                        size={1}
                        font={'heading'}
                        tone={'subtle'}
                        className={styles.availability}
                        data-testid={`${warehouse.warehouseId}_unavailable`}
                      >
                        Unavailable
                      </Typography>
                    )}
                    <Typography size={1} font={'heading'} className={styles.location_header}>
                      {storeConfigMap.get(warehouse.warehouseId)?.cityState}
                    </Typography>
                    <Typography size={0.875} font={'heading'} tone={'subtle'}>
                      {storeConfigMap.get(warehouse.warehouseId)?.street}
                    </Typography>
                    <Typography size={0.875} font={'heading'} tone={'subtle'}>
                      {storeConfigMap.get(warehouse.warehouseId)?.cityStateZip}
                    </Typography>
                    <Typography size={0.875} font={'heading'} tone={'subtle'}>
                      {storeConfigMap.get(warehouse.warehouseId)?.fullWeeklyStoreHours}
                    </Typography>
                  </div>
                </div>
              </Card>
            </ErrorBoundary>
          ))}
    </Drawer>
  )
}

export default InStorePickupDrawer
